if (!window.__flavorSwatchClickBound) {
  window.__flavorSwatchClickBound = true;

  let activeAbortController = null;
  let activeJudgeMeRetryToken = 0;
  let activeJudgeMeTimer = null;

  function reExecuteScripts(container) {
    container.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script');
      [...oldScript.attributes].forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function reinitJudgeMe(token, attempt = 0) {
    const MAX_ATTEMPTS = 5;

    activeJudgeMeTimer = setTimeout(() => {
      if (token !== activeJudgeMeRetryToken) return;

      if (typeof jdgm === 'undefined') {
        if (attempt < MAX_ATTEMPTS) {
          reinitJudgeMe(token, attempt + 1);
        } else {
          console.warn('Judge.me did not load after retries, giving up.');
        }
        return;
      }

      try {
        if (typeof jdgmCacheServer !== 'undefined' && typeof jdgmCacheServer.clearAll === 'function') {
          jdgmCacheServer.clearAll();
        }
        if (typeof jdgmCacheServer !== 'undefined' && typeof jdgmCacheServer.reloadAll === 'function') {
          jdgmCacheServer.reloadAll();
        } else if (typeof jdgm.initializeWidgets === 'function') {
          // jdgm.initializeWidgets();
          reinitJudgeMe();
        }

        if (typeof jdgm.customizeReviews === 'function') {
          setTimeout(() => {
            if (token !== activeJudgeMeRetryToken) return;
            jdgm.customizeReviews();
          }, 300);
        }

        setTimeout(() => {
          if (token !== activeJudgeMeRetryToken) return;
          document.querySelectorAll('.jdgm-legacy-widget-content').forEach((el) => {
            el.style.setProperty('display', 'block', 'important');
          });
          document.querySelectorAll('.jdgm-widget-actions-wrapper a.jdgm-write-rev-link').forEach((el) => {
            el.style.setProperty('display', 'block', 'important');
          });
        }, 400);
      } catch (error) {
        console.error('Failed to initialize Judge.me:', error);
      }
    }, 2000);
  }

  function findByKey(doc, key) {
    return (
      doc.getElementById(`shopify-section-${key}`) ||
      doc.querySelector(`[id$="__${key}"]`)
    );
  }


function reinitJudgeMe() {
  const j = window.jdgm;
  if (!j) return;
  const $ = j.jQuery || j.$;

  // Point Judge.me's caches at the new DOM
  if (j.caches && $) {
    j.caches.$revWidgets = $('.jdgm-rev-widg');
    j.caches.$widgetWithReviews = $('.jdgm-widget');
    j.caches.$prevBadges = $('.jdgm-prev-badge');
  }

  // v3 no longer ships this, but initializeWidgets() still calls it
  if (typeof j.setupMediaGallery !== 'function') j.setupMediaGallery = () => {};

  try { j.initializeWidgets(); } catch (e) { console.warn('Judge.me reinit failed', e); }
  j.batchRenderBadges?.();
}

  // Shared swap routine used by both the click handler and popstate.
  // pushHistory=true when the user is actively selecting a swatch (click);
  // false when we're just re-rendering to match a URL the browser already
  // navigated to (back/forward).
  async function swapToUrl(url, { pushHistory, handle }) {
    const wrap = document.querySelector('[data-root-url]');
    if (!wrap) return false;

    let syncKeys = [];
    try {
      syncKeys = JSON.parse(wrap.getAttribute('data-sync-keys') || '[]');
    } catch (err) {
      console.error('Invalid data-sync-keys JSON:', err);
      return false;
    }
    if (!syncKeys.length) return false;

    const productInfo = document.querySelector('product-info');
    if (!productInfo) return false;

    if (activeAbortController) {
      activeAbortController.abort();
    }
    activeJudgeMeRetryToken++;
    if (activeJudgeMeTimer) {
      clearTimeout(activeJudgeMeTimer);
      activeJudgeMeTimer = null;
    }

    const controller = new AbortController();
    activeAbortController = controller;
    const myToken = activeJudgeMeRetryToken;

    productInfo.classList.add('flavor-swatches-loading');
    productInfo.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) throw new Error(`Failed to load page: ${res.status}`);
      const html = await res.text();
      const targetDoc = new DOMParser().parseFromString(html, 'text/html');

      if (pushHistory) {
        history.pushState({}, '', url);
      }
      document.title = targetDoc.title;

      let swappedAny = false;
      syncKeys.forEach((key) => {
        const currentWrapper = findByKey(document, key);
        const targetWrapper = findByKey(targetDoc, key);
        if (!currentWrapper || !targetWrapper) return;

        currentWrapper.innerHTML = targetWrapper.innerHTML;
        reExecuteScripts(currentWrapper);
        swappedAny = true;
      });

      if (!swappedAny) {
        throw new Error('No matching sections found to swap');
      }

      reinitJudgeMe(myToken);
      window.dispatchEvent(new CustomEvent('flavor:changed', { detail: { url, handle } }));
      return true;
    } catch (err) {
      if (err.name === 'AbortError') {
        return false;
      }
      console.error('Flavor swatch swap failed, falling back to full page navigation:', err);
      // For a popstate-triggered failure the URL is already correct, so this
      // just forces a normal reload of the current (already-correct) URL.
      window.location.href = url;
      return false;
    } finally {
      if (activeAbortController === controller) {
        productInfo.classList.remove('flavor-swatches-loading');
        productInfo.removeAttribute('aria-busy');
      }
    }
  }

  document.addEventListener('click', async (e) => {
    const swatch = e.target.closest('[data-flavor-swatch]');
    if (!swatch || swatch.classList.contains('flavor-swatch--selected')) return;

    const handle = swatch.getAttribute('data-product-handle');
    const wrap = swatch.closest('[data-root-url]');
    if (!handle || !wrap) return;

    let root = wrap.getAttribute('data-root-url') || '/';
    if (!root.endsWith('/')) root += '/';
    const url = `${root}products/${handle}`;

    await swapToUrl(url, { pushHistory: true, handle });
  });

  // Browser back/forward: the URL bar already changed by the time this fires,
  // so just re-render to match it — no pushState here.
  window.addEventListener('popstate', async () => {
    const handle = window.location.pathname.split('/').filter(Boolean).pop();
    await swapToUrl(window.location.href, { pushHistory: false, handle });
  });
}